import { Component, OnInit } from '@angular/core';
import { CustomLayoutService } from '@app/services/custom-layout.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-layout-list',
  templateUrl: './layout-list.component.html',
  styleUrl: './layout-list.component.scss'
})
export class LayoutListComponent implements OnInit {

  customLayouts: any[] = [];

  constructor(private CustomLayoutService: CustomLayoutService, private router: Router) { }

  async ngOnInit() {
    await this.loadcustomLayouts();
  }

  loadcustomLayouts() {
    this.CustomLayoutService.getcustomLayoutList().subscribe(data => this.customLayouts = data);
  }

  addCustomLayout() {
    this.router.navigate(['/designer/layout-form']);
  }

  editLayoutLines(customLayout: any) {
    console.log("In editlayoutlines");
    console.log(customLayout);
    let shortcode = customLayout.LayoutShortCode;
    this.router.navigate(['/designer/layout-lines', shortcode]);

  }

}
